import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Financial Module Service Stores
 */
export const financialStores: ServiceStoreConfig[] = [
  {
    name: "quotes",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "quoteId",
    },
  },
  {
    name: "quote-lines",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "quoteLineId",
    },
  },
  {
    name: "tax-rates",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 25,
    },
  },
  {
    name: "wa-tax-lookup",
    options: {
      enableErrorNotifications: true,
    },
  },
  {
    name: "payments",
    options: {
      enableErrorNotifications: true,
    },
  },
  {
    name: "invoices",
    options: {
      enableErrorNotifications: true,
    },
  },
  {
    name: "bills",
    options: {
      enableErrorNotifications: true,
    },
  },
  {
    name: "check-templates",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "check-template-elements",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "check-print-jobs",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "check-print-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "check-number-sequences",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  // ==================== General Ledger Service Stores ====================
  {
    name: "gl-accounts",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 1000,
    },
  },
  {
    name: "journal-entries",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 50,
    },
  },
  {
    name: "journal-line-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 100,
    },
  },
  {
    name: "gl-transactions",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "transactionId",
      pagination: 100,
    },
  },
  {
    name: "account-balances",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "balanceId",
      pagination: 100,
    },
  },
  {
    name: "fiscal-periods",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "periodId",
      pagination: 50,
    },
  },
  {
    name: "reconciliations",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "reconciliationId",
      pagination: 50,
    },
  },
  {
    name: "reconciliation-matches",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "matchId",
      pagination: 100,
    },
  },
  {
    name: "bank-statement-lines",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "lineId",
      pagination: 100,
    },
  },
  {
    name: "audit-log",
    options: {
      enableErrorNotifications: true,
      idField: "auditId",
      pagination: 100,
    },
  },
  // ==================== Accounts Receivable Service Stores ====================
  {
    name: "ar-invoices",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  {
    name: "ar-payments",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  {
    name: "ica-transactions",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  {
    name: "payment-entities",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  {
    name: "ar-deposits",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  // ==================== Accounts Payable Service Stores ====================
  {
    name: "ap-invoices",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  {
    name: "ap-payments",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  {
    name: "nacha-files",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 100,
    },
  },
  {
    name: "vendor-ach-info",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  {
    name: "vendor-default-gl",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  // ==================== Fiscal Periods Adjustments ====================
  {
    name: "closed-period-adjustments",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 100,
    },
  },
  // ==================== Recurring Transactions Service Stores ====================
  {
    name: "recurring-transactions",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  {
    name: "recurring-transaction-instances",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
  // ==================== Purchase Orders ====================
  {
    name: "purchase-orders",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 500,
    },
  },
  // ==================== Freight Matching Service Stores ====================
  {
    name: "freight-matching-groups",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 200,
    },
  },
];
